import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
import { Hidden } from "@mui/material";

import { StyledHeaderMenuButton } from "@/components/layouts/styled";

// Component
const LoginNavigation: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Hidden lgDown>
                <Link
                    to="WhatCanBeDoneWithMyBroker"
                    data-testid="login_navigation-link-about"
                    spy
                    smooth
                    duration={500}
                >
                    <StyledHeaderMenuButton>{t("NavBar.About")}</StyledHeaderMenuButton>
                </Link>
                <Link to="AllYourFilesInOne" data-testid="login_navigation-link-all_in_one" spy smooth duration={500}>
                    <StyledHeaderMenuButton>{t("NavBar.AllInOne")}</StyledHeaderMenuButton>
                </Link>
            </Hidden>
        </>
    );
};

export default LoginNavigation;
